import {
	rosBusinessPersonExtendedQuery,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { hasProperty, propEq } from '@gov-nx/core/types';
import { getMyInvolvement } from './utils';

export const useRosExtendedQuery = () => {
	const { axiosInstance } = useAxiosInstance();
	const extendedQuery = usePoQuery(
		{
			queryKey: ['ros-extended-query'],
			queryFn: async () => rosBusinessPersonExtendedQuery(axiosInstance),
		},
		{ errorIgnoreFilter: () => true }
	);

	const extendedData =
		extendedQuery.data?.seznam?.filter(hasProperty('ico')) ?? [];

	const PFOData = extendedData.filter(propEq('typ', 'PFO'));
	const POData = extendedData.filter(propEq('typ', 'PO'));
	const personInvolvementData = getMyInvolvement(extendedData);

	const getDetailData = (ico: number) => extendedData.find(propEq('ico', ico));
	const getDetailDataByIcoAndAgenda = (ico: number, agendaCode?: string) =>
		extendedData.find(
			(item) =>
				item.ico === ico && (!agendaCode || item.agenda?.kod === agendaCode)
		);

	return {
		...extendedQuery,
		extendedData,
		PFOData,
		POData,
		personInvolvementData,
		getDetailData,
		getDetailDataByIcoAndAgenda,
	};
};
